

import React, { useState ,useEffect} from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  MenuItem,
  IconButton
} from "@mui/material";
import Footer from "../Common/Footer";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import CustomDialog from "../../CustomDialog";
import { fetchUserFromRedis } from "../HomePage/AuthonticationScreens/Register";
import { apiRequest } from '../../fetchSetup';

const BookAppointment = () => {
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [user, setUser] = useState(null);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    age: "",
    gender: "",
    service: 0,
    priority: "",
    time: "",
    paymentMethod: "",
    prescriptions: [],
    terms: false,
  });
  const [errors, setErrors] = useState({});
  const bookAppointmentApi = process.env.REACT_APP_BOOK_APPOINTMENT_API;
  const prescriptionApi = process.env.REACT_APP_PRESCRIPTION_STORE_API;
  const getservicesApi = process.env.REACT_APP_GET_SERVICES;


  const paymentprocessApi = process.env.REACT_APP_PROCESS_PAYEMENT;
  const razorpaycreationApi = process.env.REACT_APP_CREATE_RAZORPAY_ORDER;
  const razorpaykeyApi = process.env.REACT_APP_RAZORPAY_KEY;








  const fieldStyle = {
    width: "48%",
    marginBottom: "16px",
  };


  const paymentMethods = [
    { label: "Pay online", value: "online" },
    { label: "Pay at Clinic", value: "offline" },
  ];

  const gender = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const priority = [
    { label: "Low", value: "Low" },
    { label: "Normal", value: "Normal" },
    { label: "High", value: "High" },
    { label: "Emergency", value: "Emergency" },
  ];


  const [serviceList, setServiceList] = useState([]); 

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await apiRequest(getservicesApi);
        const data = await res.json();
        // Ensure the data is an array
        if (Array.isArray(data)) {
          setServiceList(data);
        } else if (data.services && Array.isArray(data.services)) {
          // if backend wraps it in an object
          setServiceList(data.services);
        } else {
          console.warn("Unexpected service response:", data);
          setServiceList([]);
        }
      } catch (err) {
        console.error("Failed to fetch services:", err);
        setServiceList([]);
      }
    };
    fetchServices();
  }, []);



  useEffect(() => {
    const getUserData = async () => {
      try {
        const userData = await fetchUserFromRedis();
        console.log("Fetched user from Redis:", userData);
  
        if (userData) {
          setUser(userData);
  
          // ✅ Prefill only email field
          setFormData((prev) => ({
            ...prev,
            email: userData.email || "",
          }));
        }
      } catch (error) {
        console.error("Error fetching user from Redis:", error);
      }
    };
  
    getUserData();
  }, []);
  



// Load Razorpay SDK
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_RAZORPAY_SCRIPT; 
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };
  
  // ==========================================
  // MAIN FORM SUBMISSION HANDLER
  // ==========================================
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form
    if (!formData.fullName || !formData.email || !formData.phone || 
        !formData.age || !formData.service || !formData.time || 
        !formData.paymentMethod) {
      setDialogMessage("Please fill all required fields");
      setDialogOpen(true);
      return;
    }
  
    if (!formData.terms) {
      setDialogMessage("Please accept terms and conditions");
      setDialogOpen(true);
      return;
    }
  
    // Handle payment based on method
    if (formData.paymentMethod === "online") {
      await handleOnlinePayment();
    } else if (formData.paymentMethod === "offline") {
      await handleOfflinePayment();
    }
  };
  
  // ==========================================
  // ONLINE PAYMENT WITH RAZORPAY
  // ==========================================
  
  const handleOnlinePayment = async () => {
    try {
      // Load Razorpay script
      const scriptLoaded = await loadRazorpayScript();
      if (!scriptLoaded) {
        setDialogMessage("Failed to load payment gateway. Please try again.");
        setDialogOpen(true);
        return;
      }
  
      // Create order
      const orderResponse = await apiRequest(razorpaycreationApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: formData.servicePrice,
          currency: "INR",
          receipt: `receipt_${Date.now()}`,
          notes: {
            name: formData.fullName,
            email: formData.email,
            service: formData.service,
          },
          service_type:formData.service,
          customer_name:formData.fullName,
          contact: formData.phone,

        }),
      });
  
      const orderData = await orderResponse.json();
      
      if (!orderResponse.ok) {
        setDialogMessage(orderData.detail || "Failed to create payment order");
        setDialogOpen(true);
        return;
      }
  
      // ⭐ OPTIMAL CONFIGURATION FOR UPI + ALL METHODS
      const options = {
        key:razorpaykeyApi,
        amount: orderData.amount,
        currency: orderData.currency,
        name: "Ayuja",
        description: `Appointment Booking - ${formData.service}`,
        order_id: orderData.id,
        // image: "https://your-logo-url.com/logo.png", // Optional
        
        // Pre-fill user details
        prefill: {
          name: formData.fullName,
          email: formData.email,
          contact: formData.phone,
        },
        
        // ⭐ Enable all payment methods including UPI
        config: {
          display: {
            blocks: {
              banks: {
                name: "Pay via UPI, Cards, or Netbanking",
                instruments: [
                  {
                    method: "upi",
                    flows: ["qr", "collect", "intent"],
                  },
                  {
                    method: "card",
                  },
                  {
                    method: "netbanking",
                  },
                  {
                    method: "wallet",
                  },
                ],
              },
            },
            sequence: ["block.banks"],
            preferences: {
              show_default_blocks: true,
            },
          },
        },
        
        // Explicitly enable methods
        method: {
          upi: true,
          card: true,
          netbanking: true,
          wallet: true,
        },
        
        handler: async function (response) {
          console.log("💳 Payment success:", response);
          await verifyAndCreateBooking(response);
        },
        
        theme: {
          color: "#3399cc",
          backdrop_color: "rgba(0, 0, 0, 0.5)",
        },
        
        modal: {
          ondismiss: function() {
            console.log("❌ Payment cancelled by user");
            setDialogMessage("Payment cancelled. Please try again.");
            setDialogOpen(true);
          },
          confirm_close: true,
          escape: true,
        },
        
        retry: {
          enabled: true,
          max_count: 3,
        },
        
        notes: {
          service_type: formData.service,
          appointment_date: formData.time,
        },
      };
  
      // Open Razorpay checkout
      const razorpay = new window.Razorpay(options);
      razorpay.open();
  
    } catch (err) {
      console.error("💥 Payment error:", err);
      setDialogMessage("Payment failed. Please try again.");
      setDialogOpen(true);
    }
  };
  // ==========================================
  // VERIFY PAYMENT AND CREATE BOOKING
  // ==========================================
  
  const verifyAndCreateBooking = async (razorpayResponse) => {
    try {
      console.log("🔍 Verifying payment...");
      
      // Step 1: Verify payment on backend
      const verifyResponse = await apiRequest(paymentprocessApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          razorpay_order_id: razorpayResponse.razorpay_order_id,
          razorpay_payment_id: razorpayResponse.razorpay_payment_id,
          razorpay_signature: razorpayResponse.razorpay_signature,
        }),
      });
  
      const verifyData = await verifyResponse.json();
  
      if (!verifyResponse.ok || !verifyData.verified) {
        console.error("❌ Payment verification failed");
        setDialogMessage("Payment verification failed. Please contact support with Payment ID: " + razorpayResponse.razorpay_payment_id);
        setDialogOpen(true);
        return;
      }
  
      console.log("✅ Payment verified:", verifyData);
  
      // Step 2: Prepare complete payment data
      const paymentData = {
        payment_id: razorpayResponse.razorpay_payment_id,
        order_id: razorpayResponse.razorpay_order_id,
        amount: formData.servicePrice,
        method: "online",
        status: "success",
        gateway: "razorpay",
        currency: "INR",
        transaction_history: [
          {
            timestamp: new Date().toISOString(),
            method: "online",
            gateway: "razorpay",
            payment_id: razorpayResponse.razorpay_payment_id,
            order_id: razorpayResponse.razorpay_order_id,
            signature: razorpayResponse.razorpay_signature,
            status: "success",
            amount: formData.servicePrice,
          }
        ],
      };
  
      // Step 3: Create booking with verified payment
      await createBooking(paymentData);
  
    } catch (err) {
      console.error("💥 Verification error:", err);
      setDialogMessage("Error verifying payment. Please contact support.");
      setDialogOpen(true);
    }
  };
  
  // ==========================================
  // OFFLINE PAYMENT (PAY AT CLINIC)
  // ==========================================
  
  const handleOfflinePayment = async () => {
    console.log("🏥 Processing offline payment...");
    
    const paymentData = {
      payment_id: `offline_${Date.now()}`,
      amount: formData.servicePrice || 0,
      method: "offline",
      status: "pending",
      gateway: null,
      transaction_history: [
        {
          timestamp: new Date().toISOString(),
          method: "offline",
          status: "pending",
        }
      ],
    };
  
    await createBooking(paymentData);
  };
  
  // ==========================================
  // CREATE BOOKING
  // ==========================================
  
  const createBooking = async (paymentData) => {
    try {
      console.log("📝 Creating booking with payment data:", paymentData);
      
      // Prepare booking payload
      const bookingPayload = {
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        // age: parseInt(formData.age),
        age: formData.age,
        gender: formData.gender,
        priority: formData.priority || "regular",
        service_type: formData.service,
        date: formData.time,
        notes: "Booked via Web App",
        source: "webApp",
        payment: paymentData,
      };
  
      // Create booking
      const bookingResponse = await apiRequest(bookAppointmentApi, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bookingPayload),
      });
  
      const bookingData = await bookingResponse.json();
  
      if (!bookingResponse.ok) {
        console.error("❌ Booking failed:", bookingData);
        setDialogMessage(bookingData.error || bookingData.detail || "Failed to book appointment");
        setDialogOpen(true);
        return;
      }
  
      console.log("✅ Booking created:", bookingData);
      const bookingId = bookingData.booking_id;
  
      // Upload prescriptions if any
      if (formData.prescriptions && formData.prescriptions.length > 0) {
        console.log("📄 Uploading prescriptions...");
        
        for (const file of formData.prescriptions) {
          const formDataObj = new FormData();
          formDataObj.append("file", file);
          
          try {
            const uploadRes = await apiRequest(`${prescriptionApi}/${bookingId}`, {
              method: "POST",
              body: formDataObj,
            });
  
            const uploadData = await uploadRes.json();
            
            if (uploadRes.ok) {
              console.log("✅ Prescription uploaded:", uploadData.file_path);
            } else {
              console.error("❌ Upload failed:", uploadData);
            }
          } catch (uploadErr) {
            console.error("❌ Upload error:", uploadErr);
          }
        }
      }
  
      // Success message
      const successMessage = `
        ✅ Appointment Booked Successfully!
        
        Booking ID: ${bookingId}
        Name: ${formData.fullName}
        Service: ${formData.service}
        Date & Time: ${formData.time}
        Payment Status: ${bookingData.payment_status}
        Payment Method: ${bookingData.payment_method}
        ${bookingData.payment_id ? `Payment ID: ${bookingData.payment_id}` : ''}
      `.trim();
  
      setDialogMessage(successMessage);
      setDialogOpen(true);
  
      // Reset form
      setFormData({
        fullName: "",
        email: "",
        phone: "",
        age: "",
        gender: "",
        priority: "",
        service: "",
        time: "",
        servicePrice: 0,
        paymentMethod: "",
        prescriptions: [],
        terms: false,
      });
  
    } catch (err) {
      console.error("💥 Booking error:", err);
      setDialogMessage("Something went wrong while booking. Please try again.");
      setDialogOpen(true);
    }
  };
  
























































  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData({
      ...formData,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
          ? Array.from(files)
          : value,
    });
  };
  const textFieldSx = ({
    textColor = "black",
    labelColor = "black",
    borderColor = "#fff",
    borderRadius = 4,
    backgroundColor = "#fff",
  } = {}) => ({
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    "& .MuiInputBase-input": {
      color: textColor,
    },
    "& .MuiInputLabel-root": {
      color: labelColor,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
      "&:hover fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
      "&.Mui-focused fieldset": {
        borderColor: borderColor,
        borderRadius: borderRadius,
      },
    },
  });
  return (
    <>
      <Box sx={{ pb: 10 ,}}>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            mt: 4,
          }}
        >
          <Box
            sx={{
              // backgroundColor: "#075372",
              backgroundColor:"#006D77",
              color: "#fff",
              p: 3,
              borderRadius: "30px",
              boxShadow: 5,
              maxWidth: "700px",
              width: "100%",
            }}
          >
            <IconButton
              onClick={() => navigate(-1)}
              sx={{ width: 80, height: 80 }}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 30, color: "#fff" }} />
            </IconButton>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", mb: 2, textAlign: "center" }}
            >
              Book Appointment
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "2%" }}>
              {/* Form Fields */}
              <TextField
              name="fullName"
              label="Full Name"
              variant="outlined"
              value={formData.fullName}
              onChange={(e) => {
                const { value } = e.target;
                // ✅ Allow only alphabets and spaces
                if (/^[A-Za-z ]*$/.test(value)) {
                  handleChange(e);
                }
              }}
              sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
            />
{/* 
            <TextField
              name="email"
              label="Email"
              variant="outlined"
              required
              type="email" 
              value={formData.email}
              onChange={(e) => {
                const { value } = e.target;
                handleChange(e);

                // ✅ Live email validation
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                  setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
                } else {
                  setErrors((prev) => ({ ...prev, email: "" }));
                }
              }}
              sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
            /> */}
            <TextField
              name="email"
              label="Email"
              variant="outlined"
              required
              type="email"
              value={formData.email}
              onChange={(e) => {
         
              }}
              InputProps={{
                readOnly: true, 
                style: { color: "black" }, 
              }}
              sx={{
                ...fieldStyle,
                ...textFieldSx({ textColor: "black", borderColor: "white" }),
              }}
            />

              <TextField
                name="phone"
                label="Phone"
                variant="outlined"
                required
                value={formData.phone}
                onChange={(e) => {
                  const { value } = e.target;
              
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
              
                    if (value.length < 10) {
                      setErrors((prev) => ({ ...prev, phone: "Phone number must be 10 digits" }));
                    } else {
                      setErrors((prev) => ({ ...prev, phone: "" }));
                    }
                  }
                }}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              />
              
              <TextField
                name="age"
                label="Age"
                variant="outlined"
                required
                type="number"
                value={formData.age}
                onChange={(e) => {
                  const { value } = e.target;
              
                  if (/^\d{0,2}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                inputProps={{ maxLength: 2, inputMode: "numeric", pattern: "[0-9]*" }}
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              />

              <TextField
                select
                label="Gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {gender.map((g, i) => (
                  <MenuItem key={i} value={g.value}>
                    {g.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                select
                label="Priority"
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {priority.map((p, i) => (
                  <MenuItem key={i} value={p.value}>
                    {p.label}
                  </MenuItem>
                ))}
              </TextField>



            <TextField
              select
              name="service"
              label="Select Service"
              value={formData.service}
              onChange={(e) => {
                const selectedService = serviceList.find(
                  (s) => s.name === e.target.value
                );
                setFormData({
                  ...formData,
                  service: selectedService?.name || "",
                  servicePrice: selectedService?.price || 0,
                });
              }}
              variant="outlined"
              required
              sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
            >
              {/* Placeholder option */}
              <MenuItem value="" disabled>
                Please select service
              </MenuItem>

              {serviceList.map((s, i) => (
                <MenuItem key={i} value={s.name}>
                  {s.name}
                </MenuItem>
              ))}
            </TextField>

              <TextField
                name="time"
                type="datetime-local"
                label="Appointment Time *"
                value={formData.time}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
                InputLabelProps={{ shrink: true }}
                inputProps={{ min: new Date().toISOString().slice(0, 16) }}
              />

              <TextField
                select
                label="Payment Method"
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleChange}
                variant="outlined"
                required
                sx={{ ...fieldStyle, ...textFieldSx({ textColor: "black", borderColor: "white" }) }}
              >
                {paymentMethods.map((method, i) => (
                  <MenuItem key={i} value={method.value}>
                    {method.label}
                  </MenuItem>
                ))}
              </TextField>

              

              <Box
                sx={{ width: "100%", backgroundColor: "#fff", borderRadius: 4, p: 1 }}
              >
                <input
                  type="file"
                  name="prescriptions"
                  multiple
                  accept="image/*,.pdf"
                  onChange={handleChange}
                  style={{ display: "block", width: "100%", padding: "10px", borderRadius: "4px" }}
                />
                {formData.prescriptions.length > 0 && (
                  <Box sx={{ mt: 1 }}>
                    <Typography variant="body2" color="#000">
                      Selected Files:
                    </Typography>
                    <ul style={{ color: "black", paddingLeft: "20px" }}>
                      {formData.prescriptions.map((file, index) => (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <span>{file.name}</span>
                          <IconButton
                            size="small"
                            onClick={() => {
                              setFormData((prev) => ({
                                ...prev,
                                prescriptions: prev.prescriptions.filter((_, i) => i !== index),
                              }));
                            }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </li>
                      ))}
                    </ul>
                  </Box>
                )}
              </Box>

              <FormControlLabel
                control={
                  <Checkbox
                    name="terms"
                    checked={formData.terms}
                    onChange={handleChange}
                    required
                    sx={{ color: "white" }}
                  />
                }
                label={
                  <Typography variant="body2">
                    I accept all{" "}
                    <span style={{ color: "#4caf50" }}>terms and conditions</span>
                  </Typography>
                }
                sx={{ width: "100%" }}
              />
              {(errors.phone || errors.age) && (
            <Typography
              variant="caption"
              color="error"
              sx={{ mt: 0.5, display: "block" ,fontSize:20}}
            >
              {errors.phone && `${errors.phone}`}
              {errors.phone && errors.age ? " | " : ""}
            </Typography>
          )}
            </Box>

            <Box textAlign="center" mt={2}>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#66f2a7",
                  color: "#003333",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  width: "50%",
                  py: 1.2,
                  "&:hover": { backgroundColor: "#55d792" },
                }}
              >
                Pay & Book Now
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>

      <Footer />
      <CustomDialog
  open={dialogOpen}
  message={dialogMessage}
  onClose={() => setDialogOpen(false)}
/>

    </>
  );
};

export default BookAppointment;
